import React, { useEffect, useRef, useState } from "react";
import Close from "../../assets/icons/Close";
import { IPwaProps } from "../../interfaces";
import ImageIcon from "../../assets/icons/ImageIcon";
import { textsToTranslate } from "../../utils/translationServise";
import { Dispatch, SetStateAction } from "react";
import "./styles.scss";

interface IDescriptionModalProps extends IPwaProps {
  setIsDescriptionModalOpen: Dispatch<SetStateAction<boolean>>;
}

const DescriptionModal = ({ pwa, setIsDescriptionModalOpen }: IDescriptionModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [isModalScrolled, setIsModalScrolled] = useState<boolean>(false);
  const translations = pwa.translations || textsToTranslate;

  const handleScroll = () => {
    if (!modalRef.current) return;

    if (modalRef.current.scrollTop > 0) {
      setIsModalScrolled(true);
    } else {
      setIsModalScrolled(false);
    }
  };

  const handleOverlayClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.target === event.currentTarget) {
      setIsDescriptionModalOpen(false);
    }
  };

  useEffect(() => {
    const handleEscapeClick = (event: KeyboardEvent) => {
      if (event.code === "Escape") {
        setIsDescriptionModalOpen(false);
      }
    };
    document.body.style.overflowY = "hidden";
    window.addEventListener("keydown", handleEscapeClick);

    return () => {
      document.body.style.overflowY = "visible";
      window.removeEventListener("keydown", handleEscapeClick);
    };
  }, []);
  return (
    <div className="modal-backdrop" onClick={handleOverlayClick}>
      <div ref={modalRef} className={"modal"} onScroll={handleScroll}>
        <div className={`modal-header ${isModalScrolled && "modal-border"}`}>
          <div className="modal-header-icon-wrapper">
            {pwa?.creatives?.icon ? (
              <img src={pwa.creatives.icon} alt="app icon" className="modal-header-icon" />
            ) : (
              <ImageIcon />
            )}
          </div>
          <div className="modal-header-text-wrapper">
            <h2 className="modal-header-title">{pwa?.appName}</h2>
            <h3 className="modal-header-subtitle">{translations.description}</h3>
          </div>
          <div className="button-wrapper">
            <button
              className="modal-close-button"
              type="button"
              onClick={() => {
                setIsDescriptionModalOpen(false);
              }}
            >
              <Close />
            </button>
          </div>
        </div>
        <div className="modal-description-wrapper">
          <p className="modal-description-text">{pwa.description}</p>
          <ul className="modal-description-list">
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.appVersion}</h4>
              <p className="modal-description-list-text">5.400.0</p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.lastAppUpdate}</h4>
              <p className="modal-description-list-text">{pwa.dateOfUpdates}</p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.downloads}</h4>
              <p className="modal-description-list-text">{pwa.numberOfInst}</p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.ageRestriction}</h4>

              <p className="modal-description-list-text">
                {"18 + "}
                <a
                  className="modal-link"
                  target="_blank"
                  href="https://support.google.com/googleplay/answer/6209544?hl=ru&sjid=14845900423059059230-EU"
                >
                  {translations.ageRestrictionInfo}
                </a>
              </p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.website}</h4>
              <p className="modal-description-list-text description-email">{pwa.developerSite}</p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.email}</h4>
              <p className="modal-description-list-text description-email">{pwa.developerEmail}</p>
            </li>
            <li className="modal-description-list-item">
              <h4 className="modal-description-list-title">{translations.developer}</h4>
              <p className="modal-description-list-text ">{pwa.author}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DescriptionModal;
